import PropTypes from "prop-types";
import StepIndicatorIcon from "../../icons/StepIndicatorIcon";
import CompletedStepIcon from "../../icons/CompletedStepIcon";
import { styled } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

const StepIconRoot = styled("div")(({ theme, ownerState }) => ({
  display: "flex",
  alignItems: "center",
}));

export default function StepIconPlus({ active, completed, className}) {
  return (
    <StepIconRoot ownerState={{ active }} className={className + active ? "" : "border p-0"} sx={{boxShadow: active ? "0px 0px 2px 3px var(--orange50)" : "",borderRadius: "20px"}}>
       <AddIcon width={active ? "38px" : "32px"} />
    </StepIconRoot>
  );
}

StepIconPlus.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};
